module.exports = __webpack_public_path__ + "img/Full_White_Atkins_logo.2139a188.png";